import { memo } from "react";
import { Navigate } from "react-router-dom";
import { FUND_REQUEST_ROUTES } from "../../constants";

/** Live fund-request redirects the old launcher to transactions. */
export const CashDepositPage = memo(() => (
  <Navigate to={FUND_REQUEST_ROUTES.TRANSACTIONS} replace />
));
